var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('blur-image', {
    attrs: {
      "src": _vm.poster
    }
  }), _vm._v(" "), _vm.deleted ? _c('live-completed', {
    attrs: {
      "text": _vm.$t('liveroom.liveDeleted'),
      "type": "deleted"
    }
  }) : [_vm.isShowIcons ? _c('liveRoomIcons', {
    attrs: {
      "vid": _vm.vid,
      "hostid": _vm.hostid
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "video-player-wrapper",
    on: {
      "click": _vm.handLiveroom
    }
  }), _vm._v(" "), _vm.completed ? _c('live-completed', {
    attrs: {
      "text": _vm.$t('liveroom.livecompleted')
    }
  }) : _vm._e()]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };